import React from 'react'
import { useState } from 'react'
import callSaveLead from '../../helpers/leads/callSaveLead.js'

/**
 * Public (no-auth) lead form for a personalised impact plan.
 *
 * The Leadlist write goes through the `saveLead` Cloud Function, not the client
 * Firestore SDK — no-auth pages do no direct CRUD, so the `Leadlist` rule can
 * close to `create: if false` (ADR-022).
 *
 * AI-CONTEXT: See docs/decisions.md (ADR-022) and functions/leads/saveLead.js
 */
const Impactplan = () => {

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [compagny, setCompagny] = useState('')
    const [showForm, setShowForm] = useState(true)
    const [saving, setSaving] = useState(false)
    const [error, setError] = useState('')

    const nameHandler = (e) => {
        setName(e.target.value)
    }

    const emailHandler = (e) => {
        setEmail(e.target.value)
    }

    const compagnyHandler = (e) => {
        setCompagny(e.target.value)
    }

    const createPlan = async () => {

        if(name === '' || email === '' || compagny === ''){
            setError('Vul alle velden in')
            return
        }

        if(saving) return // guard against double-submit

        setError('')
        setSaving(true)

        try {
            await callSaveLead({ Name: name, Email: email, Compagny: compagny })
            setShowForm(false)
        } catch (err) {
            // Surface the failure — a silent no-op here loses the lead without
            // the visitor ever knowing. The CF names the offending fields.
            console.error('Error saving lead:', err)
            setError(err?.message || 'Er ging iets mis. Probeer het opnieuw.')
        } finally {
            setSaving(false)
        }
    }


  return (
    <div className='page-container'>
        {showForm ? (
            <div id='impact-plan-form-container'>
                <h1>Gepersonaliseerd impactplan</h1>
                <p><b>Naam*</b></p>
                <input type="text" placeholder="Schrijf hier je naam" onChange={nameHandler}/>
                <p><b>E-mail*</b></p>
                <input type="text" placeholder="Schrijf hier je emailadres" onChange={emailHandler}/>
                <p><b>Bedrijfsnaam*</b></p>
                <input type="text" placeholder="Schrijf hier de naam van je bedrijf" onChange={compagnyHandler}/>
                {error !== '' && <p className='impactplan-form-error'>{error}</p>}
                <div className="button-container">
                    <button id="send-impact-plan-form" onClick={createPlan} disabled={saving}>
                        {saving ? 'Bezig…' : 'Genereer mijn plan'}
                    </button>
                </div>
            </div>
        ) : (
            <div id='impact-plan-form-container'>
                <h1>Bedankt!</h1>
                <p>We hebben je gegevens ontvangen en nemen contact met je op.</p>
            </div>
        )}

    </div>
  )
}

export default Impactplan
